import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources, type SupportedLanguage } from './resources';
import { resolveLocale } from '../utils/locale';

export const LANGUAGE_STORAGE_KEY = 'locale';
export const LEGACY_LANGUAGE_STORAGE_KEY = 'rater.language';
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';
export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'zh'];

function normalizeLanguage(value: string | null | undefined): SupportedLanguage {
  if (!value) return DEFAULT_LANGUAGE;
  if (value.startsWith('zh')) return 'zh';
  return 'en';
}

function getInitialLanguage(): SupportedLanguage {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  return resolveLocale({
    stored:
      window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
      || window.localStorage.getItem(LEGACY_LANGUAGE_STORAGE_KEY),
    navigator: window.navigator.language,
  });
}

if (!i18n.isInitialized) {
  void i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: getInitialLanguage(),
      fallbackLng: DEFAULT_LANGUAGE,
      interpolation: {
        escapeValue: false,
      },
      keySeparator: false,
      nsSeparator: false,
      returnNull: false,
    });

  i18n.on('languageChanged', (language) => {
    if (typeof window !== 'undefined') {
      const resolved = normalizeLanguage(language);
      window.localStorage.setItem(LANGUAGE_STORAGE_KEY, resolved);
      window.localStorage.setItem(LEGACY_LANGUAGE_STORAGE_KEY, resolved);
    }
  });

  if (typeof window !== 'undefined') {
    window.addEventListener('storage', (event) => {
      if (event.key !== LANGUAGE_STORAGE_KEY && event.key !== LEGACY_LANGUAGE_STORAGE_KEY) {
        return;
      }
      const next = resolveLocale({
        stored:
          window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
          || window.localStorage.getItem(LEGACY_LANGUAGE_STORAGE_KEY),
        navigator: window.navigator.language,
      });
      if (next !== i18n.language) {
        void i18n.changeLanguage(next);
      }
    });
  }
}

export function resolveLanguage(language?: string): SupportedLanguage {
  return normalizeLanguage(language);
}

export default i18n;
